/**
 * Whether a listing is in Buy Now mode for list/search UI (active window or
 * sold-as–Buy Now). Kept free of CombinedListingSearchResult to avoid import cycles.
 *
 * Keep in sync with callers that gate Buy Now pricing in List View.
 */
export function isListingBuyNowActive(params: {
  buyNow: boolean | undefined
  buyNowEndTime: Date | null
  endTime: Date
}): boolean {
  const { buyNow, buyNowEndTime, endTime } = params
  if (!buyNow || !buyNowEndTime) return false

  const end = endTime.getTime()
  const buyNowEnd = buyNowEndTime.getTime()
  const now = Date.now()

  // Sold as buy now or within buy now window.
  return end < buyNowEnd || now < buyNowEnd
}
